import React, { useEffect, useState } from 'react';

const BatchLogs = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    fetch('/api/batches')
      .then(res => res.json())
      .then(setLogs);
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: '40px auto', padding: 20 }}>
      <h2>📊 Batch Logs</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>Start Time</th>
            <th>Status</th>
            <th>SMTPs</th>
            <th>Recipients</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log => (
            <tr key={log.id}>
              <td>{new Date(log.start_time).toLocaleString()}</td>
              <td>{log.status}</td>
              <td>{log.smtp_count}</td>
              <td>{log.recipient_count}</td>
              <td>{log.duration ? `${log.duration.toFixed(1)}s` : '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BatchLogs;
